import { CardHeader } from "@mui/material";
import React, { useState } from "react";

export const DialogHeader = (props) => {
  const { title, subTitle } = props;
  return (
    <CardHeader
      title={title}
      subheader={subTitle}
      titleTypographyProps={{
        variant: "h6",
        color: "#972020",
        fontWeight: "600",
      }}
      subheaderTypographyProps={{
        color: "#532A0C",
        fontWeight: "550",
        fontSize: { sm: "20px", md: "22px" },
      }}
      sx={{
        paddingLeft: "16px",
        paddingTop: "16px",
        paddingRight: "16px",
      }}
    />
  );
};
